import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VSheet,
    { staticClass: "mx-md-5 mx-2 mt-4" },
    [
      _c(
        VCard,
        { attrs: { loading: _vm.isAppLoading } },
        [
          _c(
            VCardText,
            { staticClass: "d-flex flex-wrap py-6" },
            [
              _c(VTextField, {
                staticClass: "mr-md-2 mb-6 mb-md-0",
                attrs: {
                  label: _vm.$vuetify.lang.t("$vuetify.base.startDate"),
                  type: "date",
                  clearable: "",
                  dense: "",
                  "hide-details": "",
                  rules: [_vm.rules.required],
                },
                model: {
                  value: _vm.parameters.startDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.parameters, "startDate", $$v)
                  },
                  expression: "parameters.startDate",
                },
              }),
              _c(VTextField, {
                staticClass: "ml-0 ml-lg-4 mb-6 mb-md-0",
                attrs: {
                  label: _vm.$vuetify.lang.t("$vuetify.base.endDate"),
                  type: "date",
                  clearable: "",
                  dense: "",
                  "hide-details": "",
                  rules: [
                    _vm.rules.dateRange(
                      _vm.parameters.startDate,
                      _vm.parameters.endDate
                    ),
                  ],
                },
                model: {
                  value: _vm.parameters.endDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.parameters, "endDate", $$v)
                  },
                  expression: "parameters.endDate",
                },
              }),
            ],
            1
          ),
          _c(
            VCardActions,
            { staticClass: "justify-center my-4" },
            [
              _c(
                VBtn,
                {
                  attrs: { disabled: _vm.isAppLoading },
                  on: { click: _vm.search },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$vuetify.lang.t("$vuetify.base.submit")) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(VDivider, { staticClass: "my-4" }),
      _vm.receivingWithoutSamples.length > 0
        ? _c(
            VAlert,
            {
              staticClass: "mb-4",
              attrs: { type: "warning" },
              on: {
                click: function ($event) {
                  _vm.showWithoutSamplingDetails = true
                },
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$vuetify.lang.t(
                      "$vuetify.receiving.withoutSamplesWarning",
                      _vm.receivingWithoutSamples.length
                    )
                  ) +
                  " "
              ),
            ]
          )
        : _vm._e(),
      _c(
        VContainer,
        [
          _vm.hasSearched && _vm.filteredSummaryData.length > 0
            ? _c(
                VRow,
                [
                  _c(
                    VCol,
                    {
                      staticClass: "d-flex justify-end",
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        VBtn,
                        {
                          staticClass: "mr-auto",
                          attrs: { color: "green" },
                          on: { click: _vm.downloadExcel },
                        },
                        [_vm._v(" Download Excel ")]
                      ),
                      _vm.anyFilterApplied
                        ? _c(
                            VBtn,
                            {
                              staticClass: "mr-2",
                              attrs: { small: "", text: "", color: "red" },
                              on: { click: _vm.clearAllFilters },
                            },
                            [_vm._v(" Clear All Filters ")]
                          )
                        : _vm._e(),
                      _c(
                        VBtn,
                        {
                          attrs: { icon: "" },
                          on: { click: _vm.toggleFilters },
                        },
                        [_c(VIcon, [_vm._v("mdi-filter")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c(VExpandTransition, [
                        _vm.showFilterOptions
                          ? _c(
                              "div",
                              { staticClass: "pb-4" },
                              [
                                _c(
                                  VCard,
                                  { attrs: { outlined: "" } },
                                  [
                                    _c(VCardTitle, [_vm._v("Filters")]),
                                    _c(
                                      VCardText,
                                      [
                                        _c(
                                          VRow,
                                          [
                                            _c(
                                              VCol,
                                              { attrs: { cols: "12" } },
                                              [
                                                _c(VSelect, {
                                                  attrs: {
                                                    items: _vm.supplierOptions,
                                                    "item-text": "supplierName",
                                                    "item-value":
                                                      "supplierName",
                                                    multiple: "",
                                                    clearable: "",
                                                    label: _vm.$vuetify.lang.t(
                                                      "$vuetify.base.supplier"
                                                    ),
                                                    dense: "",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.onFilterChange(
                                                        "supplier"
                                                      )
                                                    },
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "append",
                                                        fn: function () {
                                                          return [
                                                            _c(
                                                              VBtn,
                                                              {
                                                                attrs: {
                                                                  small: "",
                                                                  text: "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.selectAll(
                                                                        "supplier"
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Select All "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              VBtn,
                                                              {
                                                                attrs: {
                                                                  small: "",
                                                                  text: "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.clearAll(
                                                                        "supplier"
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Clear "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                        proxy: true,
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    2376109558
                                                  ),
                                                  model: {
                                                    value:
                                                      _vm.selectedSuppliers,
                                                    callback: function ($$v) {
                                                      _vm.selectedSuppliers =
                                                        $$v
                                                    },
                                                    expression:
                                                      "selectedSuppliers",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          VRow,
                                          [
                                            _c(
                                              VCol,
                                              {
                                                attrs: { cols: "12", md: "6" },
                                              },
                                              [
                                                _c(VSelect, {
                                                  attrs: {
                                                    items:
                                                      _vm.filteredProductOptions,
                                                    "item-text": "productName",
                                                    "item-value": "productName",
                                                    multiple: "",
                                                    clearable: "",
                                                    label: _vm.$vuetify.lang.t(
                                                      "$vuetify.base.product"
                                                    ),
                                                    dense: "",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.onFilterChange(
                                                        "product"
                                                      )
                                                    },
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "append",
                                                        fn: function () {
                                                          return [
                                                            _c(
                                                              VBtn,
                                                              {
                                                                attrs: {
                                                                  small: "",
                                                                  text: "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.selectAll(
                                                                        "product"
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Select All "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              VBtn,
                                                              {
                                                                attrs: {
                                                                  small: "",
                                                                  text: "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.clearAll(
                                                                        "product"
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Clear "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                        proxy: true,
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    2960061238
                                                  ),
                                                  model: {
                                                    value: _vm.selectedProducts,
                                                    callback: function ($$v) {
                                                      _vm.selectedProducts = $$v
                                                    },
                                                    expression:
                                                      "selectedProducts",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              VCol,
                                              {
                                                attrs: { cols: "12", md: "6" },
                                              },
                                              [
                                                _c(VSelect, {
                                                  attrs: {
                                                    items:
                                                      _vm.filteredVehiclePlateOptions,
                                                    "item-text":
                                                      "vehiclePlateNumber",
                                                    "item-value":
                                                      "vehiclePlateNumber",
                                                    multiple: "",
                                                    clearable: "",
                                                    label: _vm.$vuetify.lang.t(
                                                      "$vuetify.worksheet.plateNumber"
                                                    ),
                                                    dense: "",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.onFilterChange(
                                                        "vehiclePlate"
                                                      )
                                                    },
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "append",
                                                        fn: function () {
                                                          return [
                                                            _c(
                                                              VBtn,
                                                              {
                                                                attrs: {
                                                                  small: "",
                                                                  text: "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.selectAll(
                                                                        "vehiclePlate"
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Select All "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              VBtn,
                                                              {
                                                                attrs: {
                                                                  small: "",
                                                                  text: "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.clearAll(
                                                                        "vehiclePlate"
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Clear "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                        proxy: true,
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    4018919862
                                                  ),
                                                  model: {
                                                    value:
                                                      _vm.selectedVehiclePlates,
                                                    callback: function ($$v) {
                                                      _vm.selectedVehiclePlates =
                                                        $$v
                                                    },
                                                    expression:
                                                      "selectedVehiclePlates",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          VRow,
                                          { staticClass: "mt-3" },
                                          [
                                            _c(
                                              VCol,
                                              {
                                                attrs: { cols: "12", md: "6" },
                                              },
                                              [
                                                _c(VTextField, {
                                                  attrs: {
                                                    type: "number",
                                                    label: _vm.$vuetify.lang.t(
                                                      "$vuetify.base.minAdjustment"
                                                    ),
                                                    dense: "",
                                                    clearable: "",
                                                    rules: [_vm.rules.minMax],
                                                  },
                                                  model: {
                                                    value: _vm.adjMin,
                                                    callback: function ($$v) {
                                                      _vm.adjMin = _vm._n($$v)
                                                    },
                                                    expression: "adjMin",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              VCol,
                                              {
                                                attrs: { cols: "12", md: "6" },
                                              },
                                              [
                                                _c(VTextField, {
                                                  attrs: {
                                                    type: "number",
                                                    label: _vm.$vuetify.lang.t(
                                                      "$vuetify.base.maxAdjustment"
                                                    ),
                                                    dense: "",
                                                    clearable: "",
                                                    rules: [_vm.rules.minMax],
                                                  },
                                                  model: {
                                                    value: _vm.adjMax,
                                                    callback: function ($$v) {
                                                      _vm.adjMax = _vm._n($$v)
                                                    },
                                                    expression: "adjMax",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        VContainer,
        [
          _c(
            VRow,
            [
              _c(
                VCol,
                { attrs: { cols: "12" } },
                [
                  _c("h4", [
                    _vm._v(
                      _vm._s(_vm.$vuetify.lang.t("$vuetify.summary.summary"))
                    ),
                  ]),
                  _c(VSimpleTable, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [
                          _vm._v(
                            _vm._s(
                              _vm.$vuetify.lang.t("$vuetify.base.supplier")
                            )
                          ),
                        ]),
                        _c("th", [
                          _vm._v(
                            _vm._s(_vm.$vuetify.lang.t("$vuetify.base.product"))
                          ),
                        ]),
                        _c("th", [_vm._v("Product Weight")]),
                        _c("th", [_vm._v("Net Adjustment")]),
                        _c("th", [_vm._v("Sample Adjustment")]),
                        _c("th", [_vm._v("Sample Adjustment (%)")]),
                        _c("th", [_vm._v("Deliveries")]),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      [
                        _vm._l(
                          _vm.filteredSummaryData,
                          function (summary, idx) {
                            return _c("tr", { key: idx }, [
                              _c("td", [_vm._v(_vm._s(summary.supplierName))]),
                              _c("td", [_vm._v(_vm._s(summary.productName))]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatNumber(summary.productWeight)
                                  )
                                ),
                              ]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatNumber(
                                      summary.existingNetAdjustmentWeight
                                    )
                                  )
                                ),
                              ]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatNumber(
                                      summary.sampleAdjustmentWeight
                                    )
                                  )
                                ),
                              ]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatNumber(
                                      summary.sampleAdjustmentPercent
                                    )
                                  ) + "%"
                                ),
                              ]),
                              _c(
                                "td",
                                [
                                  _c(
                                    VBtn,
                                    {
                                      attrs: { text: "", small: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showDetails(
                                            summary.supplierName,
                                            summary.productName
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(summary.deliveriesCount) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ])
                          }
                        ),
                        _c("tr", [
                          _c("td", [_c("strong", [_vm._v("Total")])]),
                          _c("td"),
                          _c("td", [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatNumber(
                                    _vm.summaryTotals.productWeight
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _c("td", [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatNumber(
                                    _vm.summaryTotals
                                      .existingNetAdjustmentWeight
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _c("td", [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatNumber(
                                    _vm.summaryTotals.sampleAdjustmentWeight
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _c("td", [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatNumber(
                                    _vm.summaryTotals.sampleAdjustmentPercent
                                  )
                                ) + "%"
                              ),
                            ]),
                          ]),
                          _c("td", [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.summaryTotals.deliveriesCount)),
                            ]),
                          ]),
                        ]),
                        _vm.filteredSummaryData.length === 0
                          ? _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass: "text-center",
                                  attrs: { colspan: "7" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$vuetify.lang.t(
                                          "$vuetify.dataIterator.noResultsText"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(VDivider, { staticClass: "my-4" }),
          _vm.filteredDetailedData && _vm.filteredDetailedData.length > 0
            ? _c(
                VRow,
                { ref: "detailsSection" },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c("h4", [
                        _vm._v(
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.base.detail"))
                        ),
                      ]),
                      _c(VTextField, {
                        staticClass: "mb-4",
                        attrs: {
                          label: _vm.$vuetify.lang.t("$vuetify.base.search"),
                          dense: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchText,
                          callback: function ($$v) {
                            _vm.searchText = $$v
                          },
                          expression: "searchText",
                        },
                      }),
                      _c(VDataTable, {
                        staticClass: "elevation-1",
                        attrs: {
                          headers: _vm.detailHeaders,
                          items: _vm.filteredDetailedData,
                          "items-per-page": 10,
                          "sort-by": _vm.tableOptions.sortBy,
                          "sort-desc": _vm.tableOptions.sortDesc,
                          "multi-sort": "",
                        },
                        on: {
                          "update:sortBy": function ($event) {
                            return _vm.$set(_vm.tableOptions, "sortBy", $event)
                          },
                          "update:sort-by": function ($event) {
                            return _vm.$set(_vm.tableOptions, "sortBy", $event)
                          },
                          "update:sortDesc": function ($event) {
                            return _vm.$set(
                              _vm.tableOptions,
                              "sortDesc",
                              $event
                            )
                          },
                          "update:sort-desc": function ($event) {
                            return _vm.$set(
                              _vm.tableOptions,
                              "sortDesc",
                              $event
                            )
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "top",
                              fn: function () {
                                return [
                                  _c(
                                    VToolbar,
                                    { attrs: { flat: "" } },
                                    [
                                      _c(VToolbarTitle, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$vuetify.lang.t(
                                                "$vuetify.sideBar.purchasedBattery"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "item.productWeight",
                              fn: function ({ item }) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatNumber(item.productWeight)
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "item.netAdjustment",
                              fn: function ({ item }) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatNumber(item.netAdjustment)
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "item.sampleAdjustment",
                              fn: function ({ item }) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatNumber(item.sampleAdjustment)
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "item.sampleAdjustmentPct",
                              fn: function ({ item }) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatNumber(
                                          item.sampleAdjustmentPct
                                        )
                                      ) + "%"
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "item.receivingWorksheetId",
                              fn: function ({ item }) {
                                return [
                                  _c(
                                    VBtn,
                                    {
                                      attrs: {
                                        text: "",
                                        small: "",
                                        color: "primary",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openWorksheetDialog(
                                            item.receivingWorksheetId,
                                            item.supplierName,
                                            item.productName
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(item.receivingWorksheetId) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item.batterySamplingWorksheetId",
                              fn: function ({ item }) {
                                return [
                                  _c(
                                    VBtn,
                                    {
                                      attrs: {
                                        text: "",
                                        small: "",
                                        color: "primary",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openWorksheetDialog(
                                            item.batterySamplingWorksheetId,
                                            item.supplierName,
                                            item.productName
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            item.batterySamplingWorksheetId
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "body.append",
                              fn: function ({}) {
                                return [
                                  _c("tr", [
                                    _c("td", [_c("strong", [_vm._v("Total")])]),
                                    _c("td"),
                                    _c("td"),
                                    _c("td", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatNumber(
                                              _vm.detailTotals.productWeight
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _c("td", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatNumber(
                                              _vm.detailTotals.netAdjustment
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _c("td", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatNumber(
                                              _vm.detailTotals.sampleAdjustment
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _c("td", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatNumber(
                                              _vm.detailTotals
                                                .sampleAdjustmentPct
                                            )
                                          ) + "%"
                                        ),
                                      ]),
                                    ]),
                                    _c("td"),
                                    _c("td"),
                                    _c("td"),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          446815010
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.hasSearched
            ? _c(
                VRow,
                [
                  _c(
                    VCol,
                    { staticClass: "text-center", attrs: { cols: "12" } },
                    [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$vuetify.lang.t(
                              "$vuetify.dataIterator.noResultsText"
                            )
                          )
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("custom-dialog", {
        attrs: { fullscreen: true, closeable: true },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(
                  " " +
                    _vm._s(_vm.selectedSlot.supplierName) +
                    " | " +
                    _vm._s(_vm.selectedSlot.productName || "Worksheet") +
                    " "
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "default",
            fn: function () {
              return [
                _vm.selectedWorksheetId
                  ? _c("worksheet-card", {
                      key: _vm.selectedWorksheetId,
                      staticClass: "mb-4",
                      attrs: { worksheet: _vm.selectedWorksheetId },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.showWorksheetDialog,
          callback: function ($$v) {
            _vm.showWorksheetDialog = $$v
          },
          expression: "showWorksheetDialog",
        },
      }),
      _c(
        "custom-dialog",
        {
          attrs: { closeable: true, "max-width": "600px" },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function () {
                return [_vm._v(" Receiving Without Samples Details ")]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.showWithoutSamplingDetails,
            callback: function ($$v) {
              _vm.showWithoutSamplingDetails = $$v
            },
            expression: "showWithoutSamplingDetails",
          },
        },
        [
          _c(
            VCardText,
            [
              _c(VSimpleTable, [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v("Worksheet ID")]),
                    _c("th", [_vm._v("Process Date")]),
                    _c("th", [_vm._v("Supplier")]),
                    _c("th", [_vm._v("Vehicle Plate")]),
                  ]),
                ]),
                _c(
                  "tbody",
                  _vm._l(_vm.receivingWithoutSamples, function (item, index) {
                    return _c("tr", { key: index }, [
                      _c("td", [_vm._v(_vm._s(item.receivingWorksheetId))]),
                      _c("td", [
                        _vm._v(_vm._s(_vm.formatDate(item.processDate))),
                      ]),
                      _c("td", [_vm._v(_vm._s(item.supplierName))]),
                      _c("td", [_vm._v(_vm._s(item.receivingVehiclePlate))]),
                    ])
                  }),
                  0
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }